import CategoryTable from "../components/CategoryTable";

export default function CategoriesPage() {
	return <CategoryTable />;
}
